import { useEffect } from 'react';

export const useOnHoverOutside = (ref: React.MutableRefObject<HTMLDivElement>, handler: (event: Event) => void): void => {
  useEffect(() => {
    const listener = (event: Event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mouseout', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mouseout', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
